import { Button, Sheet } from '@gravity-ui/uikit';
import { CANCEL, DELETE, DELETE_QUESTION } from 'features/blank/constants';
import { Xmark } from '@gravity-ui/icons';
import styles from './styles.module.scss';

export const SheetMenuDelete = ({ visibleDelete, setVisibleDelete, onConfirm }: any) => {
	return (
		<Sheet
			visible={visibleDelete}
			onClose={() => setVisibleDelete(false)}
			title="Подтверждение удаления"
			className={styles.sheet_actions}
		>
			<div className={styles.sheet__close}>
				<Button view="flat">
					<Xmark onClick={() => setVisibleDelete(false)} cursor="pointer" />
				</Button>
			</div>
			<div className={styles.sheet_actions__content}>{DELETE_QUESTION}</div>
			<div className={styles.sheet_actions__btns}>
				<Button
					onClick={() => {
						onConfirm();
						setVisibleDelete(false);
					}}
					size="xl"
					view="outlined-danger"
				>
					{DELETE}
				</Button>
				<Button onClick={() => setVisibleDelete(false)} size="xl" view="outlined">
					{CANCEL}
				</Button>
			</div>
		</Sheet>
	);
};
